import React, { useContext, useState } from "react"
import * as S from "./career-apply-drawer.styles.jsx"
import Close from "../../assets/icons/close-btn.svg"
import { DrawerContext } from "../../provider"
import LetsTalkForm from "../lets-talk-form/lets-talk-form.component"
import { useMediaQuery, useTheme } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import CareerApplyForm from "../career-apply-form/career-apply-form.component"

const CareerApplyDrawer = () => {
  const { isFormApplyOpen, setIsFormApplyOpen } = useContext(DrawerContext)
  const theme = useTheme()
  const isMD = useMediaQuery(theme.breakpoints.down("sm"))
  const [successMessage, setSuccessMessage] = useState(null)
  return (
    <S.Wrapper
      anchor="right"
      open={isFormApplyOpen}
      transitionDuration={700}
      onClose={() => setIsFormApplyOpen(false)}
    >
      <S.InnerWrapper>
        {isMD ? (
          <S.LogoContainerMobile>
            <S.ShortLogo />
            <S.CloseButton onClick={() => setIsFormApplyOpen(false)}>
              <CloseIcon style={{ color: "#F8F8F8" }} />
            </S.CloseButton>
          </S.LogoContainerMobile>
        ) : (
          <S.LogoContainer>
            <S.CloseButton onClick={() => setIsFormApplyOpen(false)}>
              <Close />
            </S.CloseButton>
          </S.LogoContainer>
        )}
        {!successMessage ? (
          <>
            <S.Title>Postula Ahora</S.Title>
            <S.InfoGrid container spacing={3}>
              <S.FormGrid item xs={12}>
                <S.InfoForm>Listo para empezar?</S.InfoForm>
                <CareerApplyForm setSuccessMessage={setSuccessMessage} />
              </S.FormGrid>
            </S.InfoGrid>
          </>
        ) : (
          <S.SuccessMessage>
            <p>{successMessage}</p>
          </S.SuccessMessage>
        )}
      </S.InnerWrapper>
    </S.Wrapper>
  )
}
export default CareerApplyDrawer
